let currentIteration = null;

export function InteractiveMovingHandlerGenerator( walkPhaseStepsArr ) {

	var stepTimeout = 10; // millisekunteja iterattioiden välissä

	if (walkPhaseStepsArr.length < 3) console.warn( "INVALID walkPhaseStepsArr" );
	
	var doStartPhase = walkPhaseStepsArr[0]                              || doStartPhaseDefault;
	var doEndPhase   = walkPhaseStepsArr[ walkPhaseStepsArr.length - 1 ] || doEndPhaseDefault;

	var arr = walkPhaseStepsArr.slice( 1, walkPhaseStepsArr.length - 1 );

	var phase_n = 0, phase_i = 0;

	var original_values;

	return function iterativeMovingHandler( argv1, argv2, argv3 ) {

		if (currentIteration) {
			currentIteration.resolve();
		}

		currentIteration = { doStartPhase, doEndPhase, arr, argv1, argv2, argv3, resolve, reject };

		doInitialPhase();

		try {

			doStartPhase();

			iterator();

		} catch (error) {
			reject( error );
		}


		function resolve() {
			console.debug( "player.iterativeMovingHandler :: iterator().finally()" );

			phase_i += 100; // Purkkatoteutus, jolla pakotetaan iterointi loppumaan

			doEndPhase();

			clearTimeout( player.iterativeMovingTimeout );
			player.iterativeMovingTimeout = null;

			currentIteration = null;
		}

		function reject( error ) {
			console.debug( "player.iterativeMovingHandler :: iterator().catch()" );
			console.error( "player.iterativeMovingHandler :: iterator().catch() :: error =", error );

			resolve();
		}

		function iterator() {

			try {

				if (!arr[ phase_n ]) {
					if (arr[ phase_n + 1 ]) {
						phase_n++;
						phase_i = 0;
					} else {
						throw "player.iterativeMovingHandler :: Current phase_n unknown, so is next. Aborting!";
					}
				}

				if (!arr[ phase_n ][ phase_i ]) {
					if (arr[ phase_n ][ phase_i + 1 ]) {
						phase_i++;
					} else {
						throw "player.iterativeMovingHandler :: Current phase_i unknown, so is next. Aborting!";
					}
				}

				// funktio palauttaa true, kun sen phase on valmis, siis kun ollaan valmiina siirtymään seuraavaan phaseen
				var ret = arr[ phase_n ][ phase_i ]( phase_i, argv1, argv2, argv3 );

				if (ret) console.debug( "player.iterativeMovingHandler :: iterator() :: Step function signaled that phase is ready!" );

				// Jos funktio on signaloitunut phasen olevan valmis TAI seuraavaa askelta ei löydy niin pyritään siirtymään seuraavaan phaseen
				if (ret || !arr[ phase_n ][ phase_i + 1 ]) {
					phase_n++;
					phase_i = 0;
					
					// Tarkastellaan, onko seuraavaa vaihetta olemassa ja jos ei, oletetaan että päästiin loppuun onnistuneesti!
					if (!arr[ phase_n ] || !arr[ phase_n ][ phase_i ]) return resolve();

				} else {
					// Muutoin jatketaan nykyistä phasea ja siirrytään seuraavaan askeleeseen
					
					phase_i++;
				}
			
				player.iterativeMovingTimeout = setTimeout( iterator, stepTimeout );

			} catch (error) {
				reject( error );
			}
		}
	}

	function doInitialPhase() {

		phase_n = 0;
		phase_i = 0;

		try {
			if (player.iterativeMovingTimeout) {
				clearTimeout( player.iterativeMovingTimeout );
				player.iterativeMovingTimeout = null;
			}
		} catch (error) {
			console.error( error );
		}
	}

	function doStartPhaseDefault() {

		original_values = {
			player_opts_disableGravity           : !!player.opts.disableGravity,
			player_opts_disableWalls             : !!player.opts.disableWalls,
			player_keyboard_controls_disabled    : !!player.$keyboardControlsDisabled,
			player_camera_controls_disabled      : !!player.$cameraControlsDisabled,
			player_camera_zoom_controls_disabled : !!player.$cameraZoomControlsDisabled
		};

		player.$keyboardControlsDisabled = true;
		player.$cameraControlsDisabled = true;
		player.$cameraZoomControlsDisabled = true;

		// Pitää ottaa pois käytöstä sillä update()'ssa ajettaessa muodostuu "tärinää" jos kohdeobjekti on kameraa ylempänä
		player.opts.disableGravity = true;
		
		// Poistetaan käytöstä koska tarkistus hidastaa askellusta eikä törmäsylaskentaa tarvita
		player.opts.disableWalls   = true;
	}

	function doEndPhaseDefault() {

		player.$keyboardControlsDisabled   = !!original_values.player_keyboard_controls_disabled;
		player.$cameraControlsDisabled     = !!original_values.player_camera_controls_disabled;
		player.$cameraZoomControlsDisabled = !!original_values.player_camera_zoom_controls_disabled;
		player.opts.disableGravity         = !!original_values.player_opts_disableGravity;
		player.opts.disableWalls           = !!original_values.player_opts_disableWalls;

		original_values = null;
	}
}
